module.exports = __webpack_public_path__ + "static/media/heroku.a5665824.jpg";